import React from 'react';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/hooks/use-language';
import { useGroups } from '@/hooks/use-groups';
import { useToast } from '@/hooks/use-toast';
import { UserMinus } from 'lucide-react';

interface GroupMemberActionsProps {
  groupId: string;
  memberId: string;
  memberName: string;
  isCurrentUser?: boolean;
  canRemove?: boolean;
}

export function GroupMemberActions({
  groupId,
  memberId,
  memberName,
  isCurrentUser = false,
  canRemove = false
}: GroupMemberActionsProps) {
  const { t } = useLanguage();
  const { removeMemberFromGroup } = useGroups();
  const { toast } = useToast();

  const handleRemoveMember = async () => {
    try {
      await removeMemberFromGroup(groupId, memberId);
      toast({
        title: t('groups.memberRemoved'),
        description: `${memberName} removed from group`
      });
    } catch (error) {
      toast({
        title: t('common.error'),
        description: t('groups.error'),
        variant: 'destructive'
      });
    }
  };

  if (!canRemove) return null;

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={handleRemoveMember}
      className="text-muted-foreground hover:text-destructive"
    >
      <UserMinus className="h-3 w-3" />
    </Button>
  );
}